export enum ClientConnectNotificationType {
    SMS = 'sms',
    Email = 'email',
    Whatsapp = 'whatsapp'
}
